import i18n from "@/i18n";

export const rateDescription = (product) => {
  const texts = [];
  const description = product?.productDescription?.description;
  const name = product?.productDescription?.name;

  if (description) {
    texts.push(description);
  } else if (name) {
    texts.push(name);
  }

  const items = texts.map((text) => {
    text = text.replace(/<\/?[^>]+(>|$)/g, "");
    return `<li class="mb-2"><span class="text-main">♦</span> ${text}</li>`;
  });

  return `<ul>${items.join("")}</ul>`;
};

export const cancellationPolicyText = (product) => {
  const descriptions = product.cancelPolicies.map(
    ({ text }) =>
      `<li class="mb-2"><span class="text-main">♦</span> ${text}</li>`
  );

  return `<ul>${descriptions.join("")}</ul>`;
};

export const paymentPolicyText = (product) => {
  const percent = product.paymentPolicy?.percent;
  let text = "";
  if (percent && percent === 100) {
    text = i18n.t("property.paymentPolicyFull");
  } else if (percent) {
    text = i18n.t("property.paymentPolicyPercent", { percent: percent });
  }
  if (text) {
    return `<ul><li class="mb-2"><span class="text-main">♦</span> ${text}</li></ul>`;
  }

  return "";
};
